(ns ui.view.transaction-process.cards.transaction-summary
  (:require
   [common.localization :refer [tr]]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.view.transaction-process.event :as event]
   [ui.view.transaction-process.sub :as sub]))

(defn- summary-field
  [{:keys [label value]}]
  [:div {:class "mb-2"}
   [:div {:class "text-xs m-0 text-gray-500"} label]
   [:div {:class "text-sm m-0 font-medium text-gray-900"} (or value "-")]])

(defn view
  [{:keys [ctx]}]
  (let [groups @(rf/subscribe [::sub/summary-groups ctx])]
    [:div {:class "bg-white rounded-lg border border-gray-200 p-4 relative"}
     [:h3 {:class "text-sm m-0 font-semibold text-gray-900 mb-1"} (tr :transaction-process/transaction-summary)]
     [button/primary-open
      {:on-click #(rf/dispatch [::event/set-show-details ctx true])
       :class    "text-xs mb-3 block p-0"}
      (tr :transaction-process/see-all-details)]
     [:div
      (doall
       (for [{:keys [group fields]} groups]
         ^{:key (or group "_")}
         [:div {:class "mb-3"}
          (when group
            [:div {:class "text-[11px] uppercase tracking-wide text-gray-400 font-semibold mb-1"}
             group])
          (doall
           (for [f fields]
             ^{:key (:field-kw f)}
             [summary-field f]))]))]]))
